import React from "react";
import "./Projects.css";
import { Link } from "react-router-dom";
import bela from "../../assets/bela.png";
import groceryy from "../../assets/groceryy.png";
import smartWatch from "../../assets/smartWatch.png";
import intellikid from "../../assets/intellikidd.png";

const Projects = () => {
  return (
    <>
      <div className="project-title">My Projects</div>
      <div className="projects">
        <div className="project-cards">
          <h3>Speakhabla BELA Web App </h3>
          <img
            src={bela}
            alt=" a pic displaying two Bela project desktop interface"
          />
          <p>
            Speakhabla BELA is an english Language testing platform that helps
            business professionals “dominate” the English Language so they can
            compete internationally in a Global Market. This was designed with
            Adobe Xd.
          </p>
          <Link to="/Portfolio/speakhabla">
            <button className="viewMore">View Details</button>
          </Link>
        </div>
        <div className="project-cards">
          <h3>IntelliKid Mobile App </h3>
          <img
            src={intellikid}
            alt="a pic displaying four Intellikid mobile interface"
          />
          <p>
            Intellikid Mobile App is a mobile application designed to connect
            parents of kids with disabilities with certified service providers
            for extra curricular activities that can aid their development and
            social behaviours. This was designed with Figma.
          </p>
          <Link to="/Portfolio/intellikid">
            <button className="viewMore">View Details</button>
          </Link>
        </div>
        <div className="project-cards">
          <h3>Fitfun smartwatch App</h3>
          <img
            src={smartWatch}
            alt="a pic displaying three smart watch interface"
          />
          <p>
            Fitfun is a smartwatch application designed with Adobe Xd and Figma
            to encourage overweight people enjoy everyday exercise by reason of
            rewards and motivations. The app also aims to recommend different
            workouts based on user information.
          </p>
          <Link to="/Portfolio/fitfun">
            <button className="viewMore">View Details</button>
          </Link>
        </div>
        <div className="project-cards">
          <h3>Loblaw's self-checkout </h3>
          <img
            src={groceryy}
            alt="a pic displaying three loblaw's selfcheckout tablet interface"
          />
          <p>
            This self checkout was designed to eliminate the problem most
            shoppers encounter while interfacing with grocery store checkout
            machines.This was designed with Figma I chose to customize it with
            Loblaw's theme/ color scheme.
          </p>
          <Link to="/Portfolio/loblaw-grocery-selfcheckout">
            <button className="viewMore">View Details</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Projects;
